// extracted by mini-css-extract-plugin
module.exports = {"Modal":"PageBuilder-module--Modal---h_7E","ModalContent":"PageBuilder-module--ModalContent--1UsOy","SupportedBrowsersList":"PageBuilder-module--SupportedBrowsersList--3bDpR"};